module.exports = __webpack_public_path__ + "static/media/assign.de023804.svg";